export default {
  1: 0,
  2: 6,
  3: 12,
  4: 3,

  6: 1,
  7: 9,
  8: 7,
  9: 13,

  11: 2,
  12: 15,
  13: 4,
  14: 10,

  16: 8,
  17: 14,
  18: 5,
  19: 11,

};
